<template>
    <section id="ModalChangeEmailSection" >
        <form>
            <fieldset>
                <div class="row col-md-12 mt-3">
                    <label>{{$t('Current Password ')}}</label>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group form-group-feedback">
                            <input :type="showPasswordType" :placeholder="$t('Enter current password...')" id="currentPassword" class="form-control mb-1" v-model="currentPassword">
                                <span class="form-control-feedback" style="margin-left: 90%;">
                                    <a class="cursor-pointer" @click="showPassword"><i :class="iconShowPassword"></i></a>
                                </span>
                                <label
                                    class="validation-invalid-label"
                                    for="variationInfo_code"
                                    v-if="!validPassword"
                                    >{{ $t("Password is incorrect. Try again.") }}</label
                                >
                            <u class="forgotPassword cursor-pointer" @click="resetPassword">{{$t('Forgot Password?')}}</u>
                        </div>
                    </div>
                </div>
                <div class="row col-md-12">
                    <label>{{$t('New Email Account ')}}</label>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <input type="email" :placeholder="$t('Enter new email account...')" id="inputEmail" class="form-control" v-model="newEmail">
                            <label
                                    class="validation-invalid-label"
                                    for="variationInfo_code"
																		style="text-transform: inherit;"
                                    v-if="!validBlacklistedEmail"
                                    >{{ $t("This email is blacklisted.") }}</label
                                >
                            <label
                                    class="validation-invalid-label"
                                    for="variationInfo_code"
																		style="text-transform: inherit;"
                                    v-if="!validExistEmail"
                                    >{{ $t("This email is already in use. Try another email.") }}</label
                                >
                            <label
                                    class="validation-invalid-label"
                                    for="variationInfo_code"
																		style="text-transform: inherit;"
                                    v-if="!validEmail"
                                    >{{ $t("The email you entered is incorrect. Try again.") }}</label
                                >
                            <label
                                class="validation-invalid-label"
                                for="variationInfo_code"
																style="text-transform: inherit;"
                                v-if="!validEmptyEmail"
                                >{{ $t("Please enter new email.") }}</label
                            >
                        </div>
                    </div>
                </div>
                <div class="form-group mt-3 mb-0">
                    <div class="text-center">
                        <button @click="submitEmail" class="btn btn-primary mr-2 btn-ladda btn-ladda-spinner ladda-button" type="button" :class="[loading ? 'disabled' : '']">
                        <i :class="[loading ? 'icon-spinner2 spinner' : 'fa-solid fa-circle-check','mr-1',]"></i>
                        {{ $t("Confirm") }}
                        </button>
                        <button type="button" class="btn btn-light" data-dismiss="modal">{{$t('Cancel')}}</button>
                    </div>
                </div>
            </fieldset>
        </form>
    </section>
</template>

<script>

import CentralApi from '@/services/endpoint/central.service'
import bcrypt from "bcryptjs";
import { localRead } from "@/store/lang";


export default {
    data() {
        return {
            showPasswordType: 'password',
            iconShowPassword: 'far fa-eye-slash',
            currentPassword: '',
            newEmail: '',
            validPassword: true,
            validBlacklistedEmail: true,
            validExistEmail: true,
            validEmail: true,
            validEmptyEmail: true,
            loading: false,
            alreadyCode: false,
            selectloading: false,
            verificationCode: '',
            refCodeId:'',
            countdown: 0,
        }
    },
    mounted() {
        this.$root.$on("countDownTimer", ()=> {
            this.countDownTimer();
        })
        this.$root.$on("sendMail", ()=> {
            this.sendMail();
        }),
        this.$root.$on("handleRegister", ()=> {
            // console.log('this. fn');
            this.handleRegister();
        })

    },
    methods: {
        resetPassword() {
            this.$parent.showModalForgotPassword = true;
        },
        showPassword() {
            this.showPasswordType = this.showPasswordType === 'password' ? 'text': 'password';
            this.iconShowPassword = this.iconShowPassword === 'far fa-eye-slash'? 'far fa-eye': 'far fa-eye-slash';
        },

        async submitEmail() {
            this.$parent.inputVerficationCode = '';
            this.message = '';
            this.validPassword = true;
            this.validBlacklistedEmail = true;
            this.validExistEmail = true;
            this.validEmail = true;
            this.validEmptyEmail = true;
            if(this.newEmail != ''){
                this.loading = true;
                this.$parent.showEmail = this.newEmail;
                const data = {email: this.newEmail, password: this.currentPassword};
                let valid = await CentralApi.Auth.isEmailValid(this.newEmail);
                if(valid.data.message != undefined){
                    if(valid.data.message == 'This email is blacklisted.'){
                        this.validBlacklistedEmail = false;
                    }else if(valid.data.message == 'This email is already registered.'){
                        this.validExistEmail = false;
                    }else if(valid.data.message == "Email Validation Issue Detected."){
                        this.validEmail = false;
                    }
                    this.loading = false;
                }
                if(valid.data.valid == true){
                    let res = await CentralApi.Auth.checkEmailAndPhone(data);
                    if(res.data.code == 'Unauthenticated'){
                        this.validPassword = false;
                        this.loading = false;
                    }else{
                        let vm = this;
                        this.sendMail().then(response => {
                            if(response){
                                this.loading = false;
                                vm.refCodeId = this.refCodeId;
                                vm.countdown = 600;
                                vm.countDownTimer();
                                $('#ModalChangeEmail').modal('hide');
                                $('#ModalVerifiEmail').modal('show');
                            }
                        });
                    }
                }
            }else {
                this.validEmptyEmail = false;
            }

        },
        countDownTimer () {
            if (this.countdown > 1) {
                setTimeout(() => {
                    this.countdown -= 1;

                    let minutes = Math.floor(this.countdown / 60);
                    let seconds = this.countdown % 60;

                    minutes = this.padMinute(minutes);
                    seconds = this.pad(seconds);

                    this.displayCountdown = `${minutes}:${seconds}`;
                    this.countDownTimer()
                }, 1000)
            }
        },
        pad(n){
            return n > 9 ? "" + n : "0" + n;
        },
        padMinute(n){
            return this.countdown >= 600 && n <= 9 ? "0" + n : "" + n;
        },
        async sendMail() {
            console.log('log:newEmail',this.newEmail);
            this.selectloading = true;
            this.verifyOption = 'verify_email';
            let params = {
                first_name: this.$parent.user.first_name,
                last_name: this.$parent.user.last_name,
                email: this.newEmail,
            };
            try {
                let data = await CentralApi.Auth.emailSendVerifyV2(params);
                const responseData = data.data.data;
                this.selectloading = false;
                this.alreadyCode = true;
                this.verificationCode = responseData.random_number;
                this.refCodeId = responseData.refcode;
                this.loading = false;
                return true;
            } catch (error) {
                this.loading = false;
                let message = error.response.data.message;
                if(message == "This email is blacklisted.") {
                    message = this.$t("Email cannot be sent to")+" "+
                            this.newEmail+" "+
                            this.$t("because this recipient is in blacklist.")+" "+
                            this.$t("If you feel this is a mistake, contact your admin.");
                }
                this.$toastr.Add({
                    type: "warning",
                    title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                    msg: message,
                    clickClose: true,
                    timeout: 5000,
                    position: "toast-top-right"
                });
                return false;
            }
        },
        handleRegister() {
            console.log('log:handleRegister');
            if (this.countdown > 0) {
                let text_inputVerficationCode = this.$parent.inputVerficationCode;
                let text_inputVerficationCode_length =
                    text_inputVerficationCode;
                let first_inputVerficationCode =
                    text_inputVerficationCode.substr(0, 3);
                let end_inputVerficationCode = text_inputVerficationCode.substr(
                    3,
                    text_inputVerficationCode_length
                );
                let full_inputVerficationCode =
                    first_inputVerficationCode +
                    "GoSaaS" +
                    end_inputVerficationCode;
                bcrypt
                    .compare(full_inputVerficationCode, this.verificationCode)
                    .then((res) => {
                        if (res === true) {
                            CentralApi.Auth.updateEmailAndPhone({email: this.newEmail});
                            $('#ModalVerifiEmail').modal('hide');
                            $('#ModalChangeEmail').modal('hide');
                            $('#email').val(this.newEmail);
                            this.$nextTick(() => {
                                this.countdown = 1;
                            });
                            this.$toastr.s(
                            this.$t("Change Email Address Success"),
                            "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success")
                            );

                        let data = null;
                        if(localRead("ref")) {
                            data['ref'] = localRead("ref");
                        }
                        if(localRead("mcode")) {
                            data['mcode'] = localRead("mcode");
                        }
                        if(localRead("uuid")) {
                            data['uuid'] = localRead("uuid");
                        }

                        if (data) {
                            this.$store.dispatch('auth/register', data).then((response) => {
                                console.log(response)
                            },
                            error => {
                                this.message = (error.response && error.response.data) || error.message || error.toString();
                                this.loading = false;
                                console.log(this.message, 'error');
                            });
                        }
                    } else {

                        this.message = "Input verification code not match, Try again!";
                    }
                });
            } else {
                this.message = "This verify code timed out!";
            }

        },
    }
}
</script>

<style scoped>
    .forgotPassword{
        color: #2196f3 ;
    }

</style>




// WEBPACK FOOTER //
// src/components/central/account/profile/ModalChangeEmail.vue